import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IIntegration } from '@/entities/integrations';

import { useDeleteIntegration } from '../../model/useDeleteIntegration';

type TIntegrationDeleteButtonProps = {
  integration: IIntegration;
};

export const IntegrationDeleteButton = ({
  integration,
}: TIntegrationDeleteButtonProps) => {
  const { t } = useTranslation();
  const { deleteIntegration, isPending } = useDeleteIntegration();

  return (
    <Tooltip title={t('integrations:delete.button')}>
      <IconButton
        aria-label={t('integrations:delete.button')}
        disabled={isPending}
        onClick={() => deleteIntegration(integration)}
      >
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};
